// Funnel analytics for the landing page. Meta Pixel is loaded from the Pixel ID stored in Admin Settings;
// every event also goes to ARK's own funnel log (admin → Analytics), PostHog (if present) and a DOM event.
import { API } from "@/lib/api";

const STANDARD_EVENTS = { LeadSubmitted: "Lead", LandingPageView: "ViewContent" };
const ATTR_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];

export function sessionId() {
  try {
    let s = sessionStorage.getItem("ark_sid");
    if (!s) {
      s = crypto.randomUUID?.() || `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
      sessionStorage.setItem("ark_sid", s);
    }
    return s;
  } catch {
    window.__arkSid = window.__arkSid || `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    return window.__arkSid;
  }
}

function logToArk(event) {
  try {
    const attr = getAttribution();
    fetch(`${API}/public/landing/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event_type: event, session_id: sessionId(), utm: attr.utm || {}, path: window.location.pathname }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* analytics must never break the page */ }
}

export function initPixel(pixelId) {
  if (!pixelId || typeof window === "undefined") return;
  if (!window.fbq) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
  }
  if (!window.__arkPixelInit) {
    window.fbq("init", pixelId);
    window.fbq("track", "PageView");
    window.__arkPixelInit = true;
  }
}

export function track(event, params = {}) {
  if (typeof window === "undefined") return;
  logToArk(event);
  if (window.fbq) {
    window.fbq("trackCustom", event, params);
    if (STANDARD_EVENTS[event]) window.fbq("track", STANDARD_EVENTS[event], params);
  }
  window.posthog?.capture?.(event, params);
  window.dispatchEvent(new CustomEvent("ark:track", { detail: { event, params } }));
}

// Remembers UTM / click ids for the visit so they survive scrolling, step changes and soft reloads.
export function captureAttribution() {
  const params = new URLSearchParams(window.location.search);
  let saved = {};
  try { saved = JSON.parse(sessionStorage.getItem("ark_attr") || "{}"); } catch { saved = {}; }
  const utm = { ...(saved.utm || {}) };
  ATTR_KEYS.forEach((k) => { if (params.get(k)) utm[k] = params.get(k); });
  const attr = {
    utm,
    landing_url: saved.landing_url || window.location.href,
    referrer: saved.referrer || document.referrer || "",
  };
  try { sessionStorage.setItem("ark_attr", JSON.stringify(attr)); } catch { /* private mode */ }
  return attr;
}

export function getAttribution() {
  try { return JSON.parse(sessionStorage.getItem("ark_attr") || "{}"); } catch { return {}; }
}
